import { MoonIcon, SunIcon } from '@heroicons/react/24/outline'
import { useTheme } from '../../context/ThemeContext'
import { useLocale } from '../../context/LocaleContext'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()
  const { t } = useLocale()
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-300 dark:hover:text-white dark:hover:bg-gray-800 transition"
      aria-label={isDark ? t('Activer le mode jour', 'Switch to light mode') : t('Activer le mode nuit', 'Switch to dark mode')}
      title={isDark ? t('Mode jour', 'Light mode') : t('Mode nuit', 'Dark mode')}
      data-e2e="btn-theme-toggle"
    >
      {isDark ? (
        <SunIcon className="w-5 h-5" aria-hidden="true" />
      ) : (
        <MoonIcon className="w-5 h-5" aria-hidden="true" />
      )}
      <span className="hidden sm:inline">{isDark ? t('Mode jour', 'Light mode') : t('Mode nuit', 'Dark mode')}</span>
    </button>
  )
}
